import React, { useEffect, useState } from 'react';
import { Avatar, Button, Grid, Paper, Typography } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';

import moment from 'moment';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import appUrls from '../../appUrls';
import { LoadingButton } from '@mui/lab';
import { deleteYearBookRequest, toggleYearBookStatusRequest } from '../../services/yearbook';
import { deleteProfileQuestionRequest, toggleProfileQuestionStatusRequest } from '../../services/profile_questions';
import { deletePollQuestionRequest, togglePollQuestionStatusRequest } from '../../services/poll_question';
import { deleteStudentRequest, toggleStudentStatusRequest } from '../../services/student';

const useStyles = makeStyles((theme) => ({
    card: {
        // padding: 10,
        width: '100%',
        background: '#fafafa'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    info: {
        display: `flex`,
        alignItems: 'center',
        marginTop: theme.spacing(1)
    },
    infoContainer: {
        minHeight: 40,
        padding: theme.spacing(1)
    },
    value: {
        marginLeft: 10
    },
    label: {
        fontWeight: 'bold'
    },
    buttonsContainer: {
        display: 'flex',
        width: '100%'
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

function StudentCard({
    _id,
    name,
    institute,
    image,
    yearBook,
    email,
    contactNumber,
    status,
    refetchList,
    getTotalStudentProfileQuestionAnswer,
    getTotalStudentPollQuestionAnswer,
    getTotalStudentGalleries,
    getTotalStudentReceiveTestimonials,
    getTotalStudentSentTestimonials,
    totalProfileQuestions,
    totalGallery,
    totalPollQuestions
}) {
    const classes = useStyles();
    const navigate = useNavigate();
    const [statusChangeLoading, setStatusChangeLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        setStatusChangeLoading(false);
    }, [status]);

    const handleStatusToggle = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Proceeding further will ${status ? 'deactivate' : 'activate'} this student.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        });

        if (result.isConfirmed) {
            setStatusChangeLoading(true);
            const data = await toggleStudentStatusRequest({ studentId: _id });
            if (data.error === false) {
                if (refetchList) refetchList();
            }
        }
    };

    const handleDelete = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `You won't be able to revert this, Proceeding further will delete this student!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        });

        if (result.isConfirmed) {
            setDeleteLoading(true);
            const data = await deleteStudentRequest({ studentId: _id });
            if (data.error === false) {
                if (refetchList) refetchList();
            }
        }
    };

    return (
        <Paper key={_id} className={classes.card} variant="outlined" elevation={0} sx={{ p: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <Avatar
                            alt={name}
                            src={`${process.env.REACT_APP_AWS_BASE_PATH}/${image}` || 'no-image'}
                            sx={{ height: 72, width: 72, mb: 1 }}
                        />
                    </Grid>
                    <Typography title={name} variant="h3" component="h3" textOverflow="ellipsis" noWrap>
                        {name}
                    </Typography>
                    <Typography title={email} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {email}
                    </Typography>
                </Grid>
                {/* <Grid item xs={6}>
                    <Typography variant="caption">Institute</Typography>
                    <Typography title={institute?.name} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {institute?.name}
                    </Typography>
                </Grid> */}
                {/* <Grid item xs={6}>
                    <Typography variant="caption">Email</Typography>
                    <Typography title={email} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {email}
                    </Typography>
                </Grid> */}
                <Grid item xs={6}>
                    <Typography component="div" variant="caption">
                        Phone
                    </Typography>

                    <Typography title={contactNumber} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {contactNumber || 'N/A'}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="caption">Profile Question</Typography>
                    <Typography title={getTotalStudentProfileQuestionAnswer} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {getTotalStudentProfileQuestionAnswer}/{totalProfileQuestions}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="caption">Poll Question</Typography>
                    <Typography title={getTotalStudentPollQuestionAnswer} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {getTotalStudentPollQuestionAnswer}/{totalPollQuestions}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="caption">Gallery</Typography>
                    <Typography title={getTotalStudentGalleries} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        {getTotalStudentGalleries}/{totalGallery}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="caption">Testimonials</Typography>

                    <Typography title={getTotalStudentGalleries} variant="h6" component="h6" textOverflow="ellipsis" noWrap>
                        <Typography variant="caption">Sent </Typography> {getTotalStudentSentTestimonials} |{' '}
                        <Typography variant="caption">Received </Typography> {getTotalStudentReceiveTestimonials}
                    </Typography>
                </Grid>

                <Grid
                    item
                    xs={12}
                    style={{
                        padding: 0
                    }}
                >
                    {/* <Grid container sx={{ px: 1, pt: 2 }} spacing={2}>
                        <Grid item xs={3}>
                            <Button
                                disableElevation
                                variant="outlined"
                                color="primary"
                                size="medium"
                                className={classes.button}
                                // startIcon={<EditIcon />}
                                fullWidth
                                onClick={() => {
                                    navigate(`${appUrls.STUDENT_EDIT}/${_id}`);
                                }}
                            >
                                <EditIcon />
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <LoadingButton
                                disableElevation
                                variant="outlined"
                                color="error"
                                size="medium"
                                className={classes.button}
                                // startIcon={<DeleteIcon />}
                                fullWidth
                                loading={deleteLoading}
                                loadingPosition="center"
                                onClick={handleDelete}
                            >
                                <DeleteIcon />
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={6}>
                            <LoadingButton
                                disableElevation
                                variant="contained"
                                color={status ? 'info' : 'error'}
                                size="medium"
                                className={classes.button}
                                fullWidth
                                loading={statusChangeLoading}
                                loadingPosition="center"
                                onClick={handleStatusToggle}
                            >
                                {status ? 'Active' : 'Inactive'}
                            </LoadingButton>
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
        </Paper>
    );
}

export default StudentCard;
